/**
 * Date della chat associati, nel fuso orario del browser (Date locale).
 */

const GIORNI = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];

const due = (n: number) => (n < 10 ? `0${n}` : String(n));

const leggi = (iso: string): Date | null => {
  const d = new Date(iso);
  return isNaN(d.getTime()) ? null : d;
};

/**
 * Giorni di calendario tra `d` e `ora` (0 = stesso giorno, 1 = ieri). Una data
 * nel futuro (orologio del browser indietro rispetto al server) vale come oggi.
 */
const giorniFa = (d: Date, ora: Date): number => {
  const a = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const b = new Date(ora.getFullYear(), ora.getMonth(), ora.getDate()).getTime();
  return Math.max(0, Math.round((b - a) / 86400000));
};

const hhmm = (d: Date) => `${due(d.getHours())}:${due(d.getMinutes())}`;

export const oraBreve = (iso: string): string => {
  const d = leggi(iso);
  return d ? hhmm(d) : '';
};

/** Separatore di giorno: 'Oggi', 'Ieri', nome del giorno entro 6 giorni, altrimenti 'GG/MM/AAAA'. */
export const etichettaGiorno = (iso: string, ora: Date = new Date()): string => {
  const d = leggi(iso);
  if (!d) return '';
  const g = giorniFa(d, ora);
  if (g === 0) return 'Oggi';
  if (g === 1) return 'Ieri';
  if (g > 1 && g <= 6) return GIORNI[d.getDay()];
  return `${due(d.getDate())}/${due(d.getMonth() + 1)}/${d.getFullYear()}`;
};

/** «alle 10:31», «ieri alle 10:31», «lunedì alle 10:31», «il 03/10/2026 alle 10:31» (Info messaggio). */
export const quando = (iso: string, ora: Date = new Date()): string => {
  const giorno = etichettaGiorno(iso, ora);
  const ore = oraBreve(iso);
  if (giorno === 'Oggi') return `alle ${ore}`;
  if (/^\d/.test(giorno)) return `il ${giorno} alle ${ore}`;
  return `${giorno.toLowerCase()} alle ${ore}`;
};

/** Data nella lista conversazioni: oggi 'HH:MM', 'Ieri', nome del giorno entro 6 giorni, altrimenti 'GG/MM/AA'. */
export const dataLista = (iso: string, ora: Date = new Date()): string => {
  const d = leggi(iso);
  if (!d) return '';
  const g = giorniFa(d, ora);
  if (g === 0) return hhmm(d);
  if (g === 1) return 'Ieri';
  if (g > 1 && g <= 6) return GIORNI[d.getDay()];
  return `${due(d.getDate())}/${due(d.getMonth() + 1)}/${due(d.getFullYear() % 100)}`;
};

export const testoUltimoAccesso = (iso: string, ora: Date = new Date()): string => {
  const d = leggi(iso);
  if (!d) return '';
  const g = giorniFa(d, ora);
  if (g === 0) return `ultimo accesso oggi alle ${hhmm(d)}`;
  if (g === 1) return `ultimo accesso ieri alle ${hhmm(d)}`;
  return `ultimo accesso il ${due(d.getDate())}/${due(d.getMonth() + 1)} alle ${hhmm(d)}`;
};

/** Data e ora estese delle viste admin: 'GG/MM/AAAA, HH:MM' (vuota se assente o non valida). */
export const dataOra = (iso: string | null | undefined): string => {
  if (!iso) return '';
  const d = leggi(iso);
  if (!d) return '';
  return d.toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};
